module.exports = __webpack_public_path__ + "img/67e3527.jpg";